module.exports = __webpack_public_path__ + "static/media/Vector.3e1de6bb.svg";